import type { ReactNode } from 'react';

import { FlyTextOverflow } from '@fly/shared-ui';
import { FlySvgSprite } from '@fly/svg';
import cn from 'classnames';

import { DistributionFormRow } from './distributionFormKeys';

export function DistributionFormRowLayout({
  row,
  children,
  comingSoon,
}: {
  row: Omit<DistributionFormRow, 'distributed'>;
  children: ReactNode;
  comingSoon?: boolean;
}) {
  return (
    <div className='flex w-full items-center justify-between gap-fly-4'>
      <div className='min-w-0 flex items-center gap-fly-2'>
        <FlySvgSprite
          name={row.packageType}
          size={16}
          className={cn(comingSoon && 'opacity-32')}
        />
        <FlyTextOverflow
          size='3'
          weight='semibold'
          color='neutral'
          highContrast
          className={cn(comingSoon && 'opacity-32', 'min-w-0 truncate')}
        >
          {row.artifactName} - #{row.versionName}
        </FlyTextOverflow>
      </div>
      {children}
    </div>
  );
}
